export default __webpack_public_path__ + "static/media/logoforhelmet.4bfa74a5.png";